module.exports = __webpack_public_path__ + "img/notice.9c20060f.png";